<template>
  <v-card>
    <v-toolbar dense :elevation="0" color="background darken-1">
      <v-toolbar-title>{{ $Amplify.I18n.get(title) }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text icon color="secondary" @click.stop="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text style="margin-bottom:-30px; margin-top: 10px">
      <v-alert
        prominent
        dense
        icon="mdi-lightbulb-outline"
        dismissible
        type="primary"
        transition="scale-transition"
      >
        <v-layout align-center wrap>
          <div>
            Nuevos filtros de rango: Anticipo y Umbral VAE
          </div>
        </v-layout>
      </v-alert>

      <v-row dense>
        <v-col cols="3" class="mr-2">
          <span class="subtitle-1 font-weight-medium black--text"
            ><v-icon class="black--text mr-2">mdi-signature-text</v-icon>
            Filtros de Texto </span
          ><br />
          <span class="black--text font-weight-light"
            >Permiten el uso de los operadores lógicos AND y OR y los comodines
            ? y *
          </span>
        </v-col>
        <v-col>
          <v-item-group v-model="selected">
            <v-container class="pa-0">
              <v-row dense>
                <v-col
                  v-for="n in textFilterList"
                  :key="n.value"
                  cols="auto"
                  md="2"
                >
                  <v-item v-slot:default="{ active, toggle }" :value="n">
                    <v-card
                      :elevation="0"
                      class="d-flex align-center "
                      height="55"
                      v-bind:class="{
                        'filter-active': active,
                        'filter-inactive': !active,
                      }"
                      @click="toggle"
                    >
                      <v-scroll-y-transition>
                        <div
                          v-if="active"
                          class="subtitle-2  flex-grow-1 text-center"
                        >
                          {{ n.label }}
                          <v-chip color="success" small v-if="n.chipLabel">{{
                            n.chipLabel
                          }}</v-chip>
                        </div>
                        <div v-else class="flex-grow-1 text-center">
                          {{ n.label }}
                          <v-chip color="success" small v-if="n.chipLabel">{{
                            n.chipLabel
                          }}</v-chip>
                        </div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-col>
      </v-row>
      <v-row my-4 class="my-1">
        <v-divider></v-divider>
      </v-row>
      <v-row dense>
        <v-col cols="3" class="mr-2">
          <span class="subtitle-1 font-weight-medium black--text"
            ><v-icon class="black--text mr-2">mdi-format-list-checks</v-icon
            >Filtro de Selección </span
          ><br />

          <span class="black--text font-weight-light"
            >Permiten filtrar seleccionando uno o más valores
          </span>
        </v-col>
        <v-col>
          <v-item-group v-model="selected">
            <v-container class="pa-0">
              <v-row dense>
                <v-col
                  v-for="n in selectionFilterList"
                  :key="n.value"
                  cols="auto"
                  md="2"
                >
                  <v-item v-slot:default="{ active, toggle }" :value="n">
                    <v-card
                      :elevation="0"
                      class="d-flex align-center "
                      height="55"
                      v-bind:class="{
                        'filter-active': active,
                        'filter-inactive': !active,
                      }"
                      @click="toggle"
                    >
                      <v-scroll-y-transition>
                        <div
                          v-if="active"
                          class="subtitle-2  flex-grow-1 text-center"
                        >
                          {{ n.label }}
                          <v-chip color="success" small v-if="n.chipLabel">{{
                            n.chipLabel
                          }}</v-chip>
                        </div>
                        <div v-else class="flex-grow-1 text-center">
                          {{ n.label }}
                          <v-chip color="success" small v-if="n.chipLabel">{{
                            n.chipLabel
                          }}</v-chip>
                        </div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-col>
      </v-row>
      <v-row my-4 class="my-1">
        <v-divider></v-divider>
      </v-row>
      <v-row dense>
        <v-col cols="3" class="mr-2">
          <span class="subtitle-1 font-weight-medium black--text"
            ><v-icon class="black--text mr-2">mdi-contain</v-icon>Filtros de
            Rango</span
          ><br />
          <span class="black--text font-weight-light"
            >Permite filtrar resultados dentro de un rango determinado.</span
          >
        </v-col>
        <v-col>
          <v-item-group v-model="selected">
            <v-container class="pa-0">
              <v-row dense>
                <v-col
                  v-for="n in rangeFilterList"
                  :key="n.value"
                  cols="auto"
                  md="2"
                >
                  <v-item v-slot:default="{ active, toggle }" :value="n">
                    <v-card
                      :elevation="0"
                      class="d-flex align-center "
                      height="55"
                      v-bind:class="{
                        'filter-active': active,
                        'filter-inactive': !active,
                      }"
                      @click="toggle"
                    >
                      <v-scroll-y-transition>
                        <div
                          v-if="active"
                          class="subtitle-2  flex-grow-1 text-center"
                        >
                          {{ n.label }}
                          <v-chip color="success" small v-if="n.chipLabel">{{
                            n.chipLabel
                          }}</v-chip>
                        </div>
                        <div v-else class="flex-grow-1 text-center">
                          {{ n.label }}
                          <v-chip color="success" small v-if="n.chipLabel">{{
                            n.chipLabel
                          }}</v-chip>
                        </div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="!selected" @click="addfilter()" color="primary">
        {{ $Amplify.I18n.get("Continuar") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from "vue";

import Vue2Filters from "vue2-filters";
import columns from "@/assets/columns";
import { AmplifyEventBus } from "aws-amplify-vue";

Vue.use(Vue2Filters);

export default {
  name: "FilterComponent",
  components: {},
  data() {
    return {
      columns,
      selected: null,
      loadingBtn: false,
      logger: {},
      headers: [{ text: "Descripción", value: "key" }],
    };
  },
  computed: {
    title() {
      return "Seleccione un filtro";
    },
    textFilterList() {
      return this.columns.filter(
        (filtro) =>
          filtro.component == "text" || filtro.component == "datatable"
      );
    },
    selectionFilterList() {
      return this.columns.filter((filtro) => filtro.component == "select");
    },
    rangeFilterList() {
      return this.columns.filter((filtro) => filtro.component == "range");
    },
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  watch: {},
  methods: {
    addfilter: function() {
      this.$store.dispatch("hideSelectFilterDialog");
      this.$store.dispatch("showAddOrEditFilterDialog");
      setTimeout(
        () => AmplifyEventBus.$emit("create-filter", this.selected),
        200
      );
      //console.log(this.selected);
    },

    close: function() {
      this.$store.dispatch("hideSelectFilterDialog");
    },
  },
};
</script>
